module.exports = __webpack_public_path__ + "static/img/dayoffCol.f60a9b06.svg";